import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { UsersSubmenuEnum } from "@/Administration/Models/UI/Users/UsersSubmenuEnum";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IUserDetailsPanelMenuStateProps {
    selectedTab: UsersSubmenuEnum;
    userType?: EmployeeType;
    userMode?: UserEditMode;
    editedUser?: EmployeeUIModel;
    canSaveDemographic?: boolean;
    canSaveConfiguration?: boolean;
    canSaveUserPracticeInfo?: boolean;
}

class UserDetailsPanelMenuComponent extends React.Component<IUserDetailsPanelMenuStateProps, never> {
    public render(): JSX.Element {
        let type = (this.props.editedUser) ? this.props.editedUser.Model.Type : this.props.userType;
        let styleColor: React.CSSProperties = { border: "solid 2px #f31f1f" };
        let isCreateMode = (this.props.userMode == UserEditMode.Create) ? true : false;
        let isEditMode = (this.props.userMode == UserEditMode.Edit) ? true : false;

        return (
            <div className="userinfo-menu">
                <div
                    className={"userinfo-menu-item" + ((this.props.selectedTab == UsersSubmenuEnum.Demography) ? " selected" : "")}
                    style={((isCreateMode || isEditMode) && (this.props.selectedTab != UsersSubmenuEnum.Demography) && !this.props.canSaveDemographic) ? styleColor : {}}
                    onClick={this.submenuClick.bind(this, UsersSubmenuEnum.Demography)}
                    data-cy="userProfile-tabDemographic"
                >
                    {cacheStore.GetString("DemographicLabel")}
                </div>
                <div
                    className={"userinfo-menu-item" + ((this.props.selectedTab == UsersSubmenuEnum.Configuration) ? " selected" : "")}
                    style={((isCreateMode || isEditMode) && (this.props.selectedTab != UsersSubmenuEnum.Configuration) && !this.props.canSaveConfiguration) ? styleColor : {}}
                    onClick={this.submenuClick.bind(this, UsersSubmenuEnum.Configuration)}
                    data-cy="userProfile-tabSettings"
                >
                    {cacheStore.GetString("SettingsLabel")}
                </div>
                {(type === EmployeeType.Practician || type === EmployeeType.Admin) && (
                    <div
                        className={"userinfo-menu-item" + ((this.props.selectedTab == UsersSubmenuEnum.Practice) ? " selected" : "")}
                        style={((isCreateMode || isEditMode) && (this.props.selectedTab != UsersSubmenuEnum.Practice) && !this.props.canSaveUserPracticeInfo) ? styleColor : {}}
                        onClick={this.submenuClick.bind(this, UsersSubmenuEnum.Practice)}
                        data-cy="userProfile-tabPractice"
                    >
                        {cacheStore.GetString("PracticeLabel")}
                    </div>
                )}
                {(type !== EmployeeType.Api) && (
                    <div
                        className={"userinfo-menu-item" + ((this.props.selectedTab == UsersSubmenuEnum.Tools) ? " selected" : "")}
                        onClick={this.submenuClick.bind(this, UsersSubmenuEnum.Tools)}
                        data-cy="userProfile-tabTools"
                    >
                        {cacheStore.GetString("ToolsLabel")}
                    </div>
                )}
            </div>
        );
    }

    private submenuClick(tab: UsersSubmenuEnum): void {
        var operation = new LocalEvent(LocalOperations.AdministrationUsers.SubmenuClick);
        operation.AddItem("selectedTab", tab);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { UserDetailsPanelMenuComponent };
